export default __webpack_public_path__ + "static/media/Office-Sedation-1.8e5e91b8.jpg";